<mat-slide-toggle
    #control
    [disabled]="disabled()"
    [ngModel]="value()"
    (change)="valueChanged($event)">
    {{ label() }}
</mat-slide-toggle>
